/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonAddressDetailInfo = {
    ADDR: string;
    ADDRT: BabylonAddressDetailInfo.ADDRT;
    BL: string;
    BLP: string;
    BLVAL: string;
    BTCBL: string;
    BTCBLVAL: string;
    FTRXUT: number;
    LTRXUT: number;
};

export namespace BabylonAddressDetailInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

